// extracted by mini-css-extract-plugin
export var chip = "_mi-0";
export var icon = "_mi-1";
export var remove = "_mi-2";
export var removeIcon = "_mi-3";